if (!customElements.get('load-more-pagination')) {
  class LoadMorePagination extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-load-more-button]');
      this.countEl = this.querySelector('.load-more-pagination__count');
      this.barFill = this.querySelector('.load-more-pagination__bar-fill');
      this.numbersWrapper = this.querySelector('.load-more-pagination__numbers');
      this.grid = document.getElementById('product-grid');

      if (this.button) {
        this.button.addEventListener('click', this.loadMore.bind(this));
      }
    }

    async loadMore() {
      const url = this.dataset.nextUrl;
      if (!url || !this.button) return;

      this.button.classList.add('loading');
      this.button.disabled = true;

      try {
        const response = await fetch(url);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const newGrid = doc.getElementById('product-grid');
        const newPagination = doc.querySelector('load-more-pagination');

        if (newGrid && this.grid) {
          Array.from(newGrid.children).forEach((item) => {
            this.grid.appendChild(item);
          });
        }

        if (newPagination) {
          const newCount = newPagination.querySelector('.load-more-pagination__count');
          if (newCount && this.countEl) this.countEl.innerHTML = newCount.innerHTML;

          const newBarFill = newPagination.querySelector('.load-more-pagination__bar-fill');
          if (newBarFill && this.barFill) this.barFill.style.width = newBarFill.style.width;

          const newNumbers = newPagination.querySelector('.load-more-pagination__numbers');
          if (newNumbers && this.numbersWrapper) this.numbersWrapper.innerHTML = newNumbers.innerHTML;

          const nextUrl = newPagination.dataset.nextUrl;
          if (nextUrl) {
            this.dataset.nextUrl = nextUrl;
          } else {
            this.dataset.nextUrl = '';
            this.button.remove();
          }
        } else {
          this.dataset.nextUrl = '';
          this.button.remove();
        }

        window.history.replaceState({}, '', url);
      } catch (error) {
        console.error('Erreur lors du chargement des produits suivants :', error);
      } finally {
        if (this.button && this.button.isConnected) {
          this.button.classList.remove('loading');
          this.button.disabled = false;
        }
      }
    }
  }

  customElements.define('load-more-pagination', LoadMorePagination);
}
